<template lang="pug">
  web-app-layout(:showLogo="true" :embedded="isEmbedded" :noPadding="true")
      smart-banner
      .complete-profile-container
        .pin-xy.bg-white.responsive-container.mx-auto
          // Confetti canvas
          canvas(ref="confettiCanvas" class="confetti-canvas")

          // Thank you section - outside the card, under the logo
          .text-center.pb-5.pt-4
              div.thank-you-title Thank You for Your Purchase!
              div.thank-you-subtitle.px-3
                | Your receipt is on the way, and your Sticker is ready to be claimed!

          // Container for both cards - desktop will show them side by side
          .cards-container.mx-auto.mb-5
              // App download card
              .card-item.complete-profile-element
                  .pt-2
                      .d-flex.flex-column
                          div.d-flex.flex-column
                              span.mt-2.mb-0.mx-auto.text-center.card-title
                                | Get the Spotlight App to Unlock Your Sticker
                              div.card-content
                                  .feature-list.text-left.mb-4
                                    div
                                        fai(type="fas" icon="download").size-16.me-2
                                        span Download your receipt
                                    div
                                        fai(type="fas" icon="gift").size-16.me-2
                                        span Claim your exclusive sticker
                                    div
                                        fai(type="fas" icon="chart-bar").size-16.me-2
                                        span Track your impact

                                  .d-flex.justify-content-center.gap-2
                                    .app-store-button.cursor-pointer(@click="openAppStore")
                                        img.app-store-icon(src="/images/apple.png" alt="Apple App Store")
                                        span App Store
                                    .app-store-button.cursor-pointer(@click="openGooglePlay")
                                        img.app-store-icon(src="/images/google-play.png" alt="Google Play")
                                        span Google Play
                                  
              // Go Home button for embedded mode
              .d-flex.justify-content-center.mt-4(v-if="isEmbedded")
                .go-home-button.cursor-pointer(@click="goToEmbedHome")
                    span Go Home

              // Profile form card - hidden in embedded mode
              .card-item.complete-profile-element(v-if="!isEmbedded")
                  .pt-2
                      .d-flex.flex-column
                          div.d-flex.flex-column
                              // Loading state while checking user
                              .text-center(v-if="isCheckingUser")
                                  .loading-spinner
                                  .loading-text Checking your account...

                              // Show forms only after user check is complete
                              template(v-else)
                                  span.mt-2.mb-0.mx-auto.text-center.card-title(v-if="!userExists")
                                    | Create Your Spotlight Account
                                  span.mt-2.mb-0.mx-auto.text-center.card-title(v-else)
                                    | Welcome Back

                                  // Subtitle for both cases
                                  .text-center.mb-3
                                      .subtitle-text
                                        | Let's personalize your experience and help you track your purchases!

                                  div.card-content
                                      // Sign In Form (when user exists)
                                      el-form(
                                        v-if="userExists"
                                        ref="refForm"
                                        :rules="signInRules"
                                        :model="signInItem"
                                        status-icon
                                        label-position="top"
                                        hide-required-asterisk=true
                                      )
                                          el-form-item(prop="phone" label="Phone" class="signin-label")
                                              el-input(
                                                v-model="signInItem.phone"
                                                type="tel"
                                                placeholder="(123) 456-7890"
                                                v-mask="'(###) ###-####'"
                                              ).sign-in-inputs

                                          el-form-item(
                                            prop="password"
                                            label="Password"
                                            class="signin-label"
                                          )
                                              el-input(
                                                v-model="signInItem.password"
                                                type="password"
                                              ).sign-in-inputs

                                          .alert.alert-danger(v-if="signInError")
                                              | Phone or password incorrect

                                          .py-2.text-center
                                              el-button(
                                                round
                                                type="success"
                                                @click="validateSignInForm"
                                                v-loading="signInLoading"
                                              ).sign-in-button Sign In

                                          .p-2.text-center
                                              el-button(link @click="gotoForgotPassword").ms-auto
                                                  span.fc-gray Forgot your password?

                                      // Complete Profile Form (when user doesn't exist)
                                      el-form(
                                        v-else
                                        ref="refForm"
                                        :rules="rules"
                                        :model="item"
                                        status-icon
                                        label-position="top"
                                        hide-required-asterisk=true
                                      )
                                          .form-row
                                              el-form-item(
                                                label="First Name"
                                                prop="firstname"
                                                class="signup-label form-item-half"
                                              )
                                                  el-input(v-model="item.firstname").sign-up-inputs

                                              el-form-item(
                                                label="Last Name"
                                                prop="lastname"
                                                class="signup-label form-item-half"
                                              )
                                                  el-input(v-model="item.lastname").sign-up-inputs

                                          el-form-item(label="Email" prop="email" class="signup-label")
                                              el-input(v-model="item.email" v-lowercase-email).sign-up-inputs

                                          .form-row
                                              el-form-item(
                                                label="Phone"
                                                prop="phone"
                                                class="signup-label form-item-half"
                                              )
                                                  el-input(
                                                    v-model="item.phone"
                                                    type="tel"
                                                    placeholder="(123) 456-7890"
                                                    v-mask="'(###) ###-####'"
                                                  ).sign-up-inputs

                                              el-form-item(
                                                label="Your Age"
                                                prop="age"
                                                class="signup-label form-item-half"
                                              )
                                                  el-input(
                                                    v-model="item.age"
                                                    type="number"
                                                    min=18
                                                    max=100
                                                    placeholder='18-100'
                                                  ).sign-up-inputs

                                          .form-row
                                              el-form-item(
                                                label="Password"
                                                prop="password"
                                                class="signup-label form-item-half"
                                              )
                                                  el-input(
                                                    v-model="item.password"
                                                    type="password"
                                                  ).sign-up-inputs

                                              el-form-item(
                                                label="Confirm Password"
                                                prop="confirmPassword"
                                                class="signup-label form-item-half"
                                              )
                                                  el-input(
                                                    v-model="item.confirmPassword"
                                                    type="password"
                                                  ).sign-up-inputs

                                          span.password-requirement.fs-12.fc-gray
                                            | Must contain an uppercase, lowercase, and special character

                                          div(v-if="error")
                                              .alert.text-alert {{ errorMessage }}
                                              .fs-14.lh-2.mx-auto
                                                  span Already have an account?
                                                  router-link(:to="`/auth/web/signin${queryString}`")
                                                      span.el-button.el-button--text.mb-1 &nbsp; Login

                                          el-checkbox(
                                            v-model="item.isMarketingAgreed"
                                            class="accept-terms-checkbox"
                                          ).me-4.mt-2
                                              .d-flex.align-items-center
                                                  span I Accept all
                                                  span(
                                                    @click="openLegalPage()"
                                                  ).el-button.el-button--text.me-5
                                                    | &nbsp;Terms and Conditions

                                          .py-4.text-center
                                              el-button(
                                                round
                                                type="success"
                                                color="#1FBEAF"
                                                @click="validateForm"
                                                v-loading="loading"
                                                :disabled="!item.isMarketingAgreed"
                                              ).sign-in-button  Continue

                                          .p-4.text-center
                                              el-button(link @click="goToHome").ms-auto
                                                  span.fc-gray Go Home

                                  // Go Home button for sign-in case
                                  .p-2.text-center(v-if="userExists")
                                      el-button(link @click="goToHome").ms-auto
                                          span.fc-gray Go Home
</template>

<script>
import {
  defineComponent, reactive, ref, computed, onMounted, nextTick, onUnmounted,
} from 'vue';
import { mask } from 'vue-the-mask';
import { signIn, checkUserExists } from '@/graphs/auth';
import { name, email, phone } from '@/data/rules';
import shared from '../../../shared';
import gqlRequest from '../dashboard/gql-request';
import WebAppLayout from '../dashboard/WebAppLayout.vue';
import SmartBanner from '../sticker/SmartBanner.vue';
import { useConfetti } from '@/composables/useConfetti';
import {
  captureEmbedOrganizationContext,
  isEmbeddedContext,
  isEmbeddedRoute,
  navigateToEmbedOrganizationHome,
  scrollEmbedToTop,
} from '@/utils/embeddedUtils';
import lowercaseEmail from '@/directives/lowercase-email.js';

export default defineComponent({
  name: 'CompleteProfile',
  directives: { mask, lowercaseEmail },
  components: {
    WebAppLayout,
    SmartBanner,
  },
  setup() {
    const {
      route,
      router,
      store,
      makeGraphRequest,
    } = shared();
    const {
      doSignUp,
      doCheckUserExists,
    } = gqlRequest();
    const { initConfetti, stopConfetti, triggerConfettiBurst } = useConfetti();

    const item = reactive({
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      password: '',
      age: null,
      isMarketingAgreed: false,
    });
    const loading = ref(false);
    const refForm = ref(null);
    const error = ref(false);
    const errorMessage = ref('');
    const { stickerId, redirect } = route.query;
    const queryString = ref('');
    const confettiCanvas = ref(null);

    // User existence check variables
    const userExists = ref(false);
    const existingUserMessage = ref('');
    const isCheckingUser = ref(true);

    // Sign In related variables
    const signInItem = reactive({
      phone: '',
      password: '',
    });
    const signInLoading = ref(false);
    const signInError = ref(false);

    const signInRules = {
      phone,
      password: [
        {
          required: true,
          message: 'Password is required',
        },
      ],
    };

    function checkAuth() {
      if (store.getters['users/isMeSignedIn']) {
        if (route.path !== '/web/') {
          router.push('/web/');
        }
      } else {
        item.email = localStorage.getItem('unregisterEmail');
        item.phone = localStorage.getItem('unregisterPhone');
      }
    }

    function checkAge(rule, value, callback) {
      const age = parseInt(value, 10);
      if (age >= 18 && age <= 100) {
        callback();
      } else {
        callback('Age should be between 18 and 100');
      }
    }

    const ageRules = [
      { required: true },
      {
        validator: checkAge, trigger: 'blur',
      },
    ];

    const passwordRules = [
      {
        required: true,
        pattern: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,12}/,
        message: 'Password is required, (at least 6 characters at least one number, one lowercase and one upper case)',
      },
    ];

    function checkConfirmPassword(rule, value, callback) {
      if (value !== item.password) {
        callback('Confirm Password should match password');
      } else {
        callback();
      }
    }

    const confirmPasswordRules = [
      { validator: checkConfirmPassword, trigger: 'blur' },
    ];

    async function checkEmailPhoneValid() {
      const result = { isValid: true, error: '' };
      const checkEmailExists = await doCheckUserExists('', item.email, '');
      const checkPhoneExists = await doCheckUserExists(item.phone, '', '');

      if (!checkEmailExists?.data || !checkPhoneExists?.data) {
        result.isValid = false;
        result.error = 'Unable to verify email and phone number. Please try again.';
      } else {
        const emailExists = checkEmailExists.data.checkUserExists != null;
        const phoneExists = checkPhoneExists.data.checkUserExists != null;

        if (emailExists || phoneExists) {
          result.isValid = false;
          if (emailExists) {
            result.error = 'Email address already in use.';
          } else if (phoneExists) {
            result.error = 'Phone number already in use.';
          }
        }
      }
      return result;
    }

    async function checkUserExistsWithEmail() {
      const emailFromUrl = route.query.email;
      if (emailFromUrl) {
        try {
          const checkEmailExists = await doCheckUserExists('', emailFromUrl, '');
          if (checkEmailExists?.data?.checkUserExists) {
            userExists.value = true;
            existingUserMessage.value = `A user with email ${emailFromUrl} already exists. Please sign in instead.`;
            // Pre-fill the email field
            item.email = emailFromUrl;
          }
        } catch (err) {
          console.error('Error checking user existence:', err);
        } finally {
          isCheckingUser.value = false;
        }
      } else {
        // If no email in URL, we're done checking
        isCheckingUser.value = false;
      }
    }

    async function signInNewUser() {
      const checkEmailExists = await doCheckUserExists('', item.email, '');
      const mPhone = checkEmailExists.data.checkUserExists.phone;
      const response = await makeGraphRequest(
        'mutation',
        signIn,
        { input: { phone: mPhone, password: item.password } },
        null,
      );
      store.commit('users/SET_IS_ME_SIGNED_IN', true);
      store.commit('users/SET_ME', response.data.signIn);

      // Trigger confetti burst on successful signup
      triggerConfettiBurst(confettiCanvas.value);

      setTimeout(() => {
        // Redirect to the intended destination
        if (redirect) {
          router.replace(redirect);
        } else if (isEmbedded.value) {
          goToEmbedHome();
        } else if (stickerId !== undefined) {
          router.push(`/web/sticker/${stickerId}`);
        } else {
          router.push('/web/');
        }
      }, 2000); // Delay navigation to show confetti
    }

    async function openLegalPage() {
      window.open(import.meta.env.VITE_LEGAL_PAGE_LINK, '_blank');
    }

    function openAppStore() {
      const appStoreLink = import.meta.env.VITE_APP_APPLE_STORE_LINK;
      if (appStoreLink) {
        openExternalLink(appStoreLink);
      }
    }

    function openGooglePlay() {
      const googlePlayLink = import.meta.env.VITE_APP_PLAY_STORE_LINK;
      if (googlePlayLink) {
        openExternalLink(googlePlayLink);
      }
    }

    function openExternalLink(url) {
      if (isEmbedded.value) {
        // For embedded contexts, redirect parent window
        try {
          if (window.top && window.top !== window.self) {
            window.top.location.href = url;
          } else {
            window.parent.postMessage({
              type: 'OPEN_EXTERNAL_LINK',
              url: url,
            }, '*');
          }
        } catch (error) {
          console.warn('Failed to redirect parent window:', error);
        }
      } else {
        window.location.href = url;
      }
    }

    async function submitSignInForm() {
      try {
        signInLoading.value = true;
        signInError.value = false;
        const checkUser = await makeGraphRequest(
          'query',
          checkUserExists,
          { phone: signInItem.phone, email: '', userId: '' },
          null,
        );
        if (checkUser.data != null) {
          const { phone: userPhone } = checkUser.data.checkUserExists;
          const response = await makeGraphRequest(
            'mutation',
            signIn,
            { input: { phone: userPhone, password: signInItem.password } },
            null,
          );
          store.commit('users/SET_IS_ME_SIGNED_IN', true);
          store.commit('users/SET_ME', response.data.signIn);

          store.dispatch('users/autoSelectFirstOrganization');

          // Redirect to the intended destination
          if (redirect) {
            router.replace(redirect);
          } else if (isEmbedded.value) {
            goToEmbedHome();
          } else if (stickerId !== undefined) {
            router.push(`/web/sticker/${stickerId}`);
          } else {
            router.push('/web/');
          }
        } else {
          signInError.value = true;
        }
      } catch (err) {
        signInError.value = true;
      } finally {
        signInLoading.value = false;
      }
    }

    function validateSignInForm() {
      refForm.value.validate((valid) => {
        if (valid) return submitSignInForm();
        return false;
      });
    }

    function gotoForgotPassword() {
      router.push('/auth/forgot-password?returnTo=web');
    }

    function goToHome() {
      router.push('/web/');
    }

    function goToEmbedHome() {
      captureEmbedOrganizationContext(route);

      const navigated = navigateToEmbedOrganizationHome(route, undefined, { router });
      if (navigated) {
        return;
      }

      router.push('/web/');
    }

    async function submitForm() {
      try {
        loading.value = true;
        error.value = false;
        const user = await doSignUp({
          firstname: item.firstname,
          lastname: item.lastname,
          email: item.email,
          phone: item.phone,
          password: item.password,
          age: parseFloat(item.age),
          isMarketingAgreed: item.isMarketingAgreed,
        });
        if (user) {
          signInNewUser();
        }
      } catch (err) {
        error.value = true;
        errorMessage.value = err;
      } finally {
        loading.value = false;
      }
    }

    async function validateForm() {
      refForm.value.validate(async (valid) => {
        if (valid) {
          const isEmailPhoneValid = await checkEmailPhoneValid();
          if (isEmailPhoneValid.isValid) {
            submitForm();
          } else {
            error.value = true;
            errorMessage.value = isEmailPhoneValid.error;
          }
        }
        return false;
      });
    }

    onMounted(async () => {
      queryString.value = window.location?.search ?? '';
      checkAuth();
      await checkUserExistsWithEmail(); // Check user existence on mount

      captureEmbedOrganizationContext(route);

      const embedded = route.query.embedded === 'true'
        || isEmbeddedRoute(route.path)
        || isEmbeddedContext();

      if (embedded) {
        scrollEmbedToTop('complete-profile-loaded');
      }

      // Initialize confetti animation
      await nextTick();
      initConfetti(confettiCanvas.value);

      if (embedded) {
        triggerConfettiBurst(confettiCanvas.value);
        window.setTimeout(() => {
          scrollEmbedToTop('complete-profile-height-settled');
        }, 400);
      }
    });

    // Check if we're in embedded context
    const isEmbedded = computed(() => {
      // Check query parameter first (most reliable for CompleteProfile)
      if (route.query.embedded === 'true') {
        return true;
      }
      // Fallback to standard embedded detection
      return isEmbeddedRoute(route.path) || isEmbeddedContext();
    });

    // Cleanup on unmount
    onUnmounted(() => {
      stopConfetti();
    });

    return {
      // refs
      confettiCanvas,
      refForm,

      // data (static)
      rules: {
        firstname: name,
        lastname: name,
        age: ageRules,
        email,
        phone,
        password: passwordRules,
        confirmPassword: confirmPasswordRules,
      },
      signInRules,

      // data (dynamic)
      loading,
      error,
      item,
      queryString,
      userExists,
      existingUserMessage,
      signInItem,
      signInLoading,
      signInError,
      isCheckingUser,
      isEmbedded,

      // methods
      validateForm,
      errorMessage,
      openLegalPage,
      openAppStore,
      openGooglePlay,
      openExternalLink,
      validateSignInForm,
      gotoForgotPassword,
      goToHome,
      goToEmbedHome,
    };
  },
});
</script>

<style scoped>
/* Complete profile container - matches other web app pages */
.complete-profile-container {
  max-width: 100%;
  margin: 0;
  padding: 24px 24px 64px 24px !important;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 24px 40px 64px 40px !important;
  }

  @media (min-width: 1024px) {
    padding: 24px 64px 64px 64px !important;
  }
}

/* Confetti canvas */
.confetti-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
}

/* Responsive container */
.responsive-container {
  max-width: 480px;
  position: relative;
  z-index: 1;
}

/* Thank you section styling */
.thank-you-title {
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 8px;
}

.thank-you-subtitle {
  font-size: 14px;
}

/* Loading state styling */
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #1FBEAF;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

.loading-text {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Subtitle styling */
.subtitle-text {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  padding: 0 16px;
}

/* Cards container for desktop layout */
.cards-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: center;
}

.card-item {
  flex: 1;
  min-width: 0;
  /* Ensure both cards have the same width */
  width: 100%;
  max-width: 100%;
}

.card-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0;
}

.card-content {
  padding: 20px;
}

/* App store buttons */
.app-store-button {
  background-color: #333;
  color: white;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  border-radius: 8px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

/* Go Home button for embedded mode */
.go-home-button {
  background-color: #1FBEAF;
  color: white;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  cursor: pointer;
  font-size: 16px;
}

.app-store-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  object-fit: contain;
  /* Make icons white */
  filter: brightness(0) invert(1);
}

.app-store-button:hover {
  background-color: #555;
}

.go-home-button:hover {
  background-color: #19a89a;
}

/* Feature list styling */
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Form layout improvements */
.form-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.form-item-half {
  flex: 1;
}

.age-requirement,
.password-requirement {
  display: block;
  margin-top: -8px;
  margin-bottom: 16px;
}

/* Mobile-only form adjustments */
@media (max-width: 767px) {
  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .form-item-half {
    width: 100%;
  }

  .app-store-button {
    font-size: 14px;
  }
}

/* Tablet styles */
@media (min-width: 768px) {
  .responsive-container {
    max-width: 700px;
  }

  .thank-you-title {
    font-size: 36px;
  }

  .thank-you-subtitle {
    font-size: 16px;
  }

  /* Keep cards stacked on tablet with equal width */
  .cards-container {
    max-width: 700px;
    margin: 0 auto;
  }

  .card-item {
    width: 100%;
    max-width: 100%;
  }
}

/* Desktop styles */
@media (min-width: 1024px) {
  .responsive-container {
    max-width: 800px;
  }

  /* Keep cards in column layout for desktop with equal width */
  .cards-container {
    flex-direction: column;
    max-width: 700px;
    margin: 0 auto;
    gap: 20px;
  }

  .card-item {
    /* Force both cards to have exactly the same width */
    width: 100%;
    max-width: 700px;
    min-width: 700px; /* This ensures they don't shrink below this width */
  }

  .thank-you-title {
    font-size: 42px;
  }

  .card-title {
    font-size: 28px;
  }

  .card-content {
    padding: 30px;
  }

  /* Form adjustments for desktop */
  .form-row {
    gap: 20px;
  }
}

/* Large desktop styles */
@media (min-width: 1440px) {
  .responsive-container {
    max-width: 1400px;
  }

  .cards-container {
    gap: 30px;
    max-width: 700px; /* Keep the same max-width as the cards */
  }

  .card-item {
    width: 100%;
    max-width: 700px;
    min-width: 700px;
  }
}

/* Legacy styles preserved */
.invite-container {
  background-color: #4ccbbf;
}

.spot-logo-container>img {
  margin: 0px 6px;
}

.invite-form-container {
  background-color: #fff;
  border-radius: 30px 30px 0px 0px;
  padding: 40px 0px;
}
</style>
